import { Component, OnInit, Input } from '@angular/core';
import { VideoService } from '../../services/video.service';

@Component({
  selector: 'app-video-instructor',
  templateUrl: './video-instructor.component.html',
  styleUrls: ['./video-instructor.component.scss']
})
export class VideoInstructorComponent implements OnInit {

  @Input()  videoItem: any;
  
  instructor : any;

  constructor(private videoService : VideoService) { }

  ngOnInit() {
    //getInstructorDetails
    //getVideoInstructor
  }

  
  ngOnChanges(){
  //  console.log("instructors"+JSON.stringify(this.videoItem.instructors[0].user));
    this.getVideoDetailsFromServer();
  }

  getVideoDetailsFromServer(){
    var instructor = this.videoItem.instructors[0].user;
    var body = {"instructor_id":""+instructor.$oid};
 //   console.log("id"+JSON.stringify(body));
    
    this.videoService.getVideoInstructor(body).subscribe((resp : any) => {
      this.onVideoDetailsSuccess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideoDetailsFetchError(err);    
    });

  }


  onVideoDetailsSuccess(resp){
  //    console.log("On Instructor : "+JSON.stringify(resp));
      this.instructor = resp;
  }

  onVideoDetailsFetchError(err){

  }


}
